<template>
	<div class="pop-up" v-show="isVisible">
		<span class="closebtn" @click="togglePopUp()">&times;</span><br>
		<div id="innerHtml">
			<ul style="list-style: none">
				<li class="bildirimSection">
					<a :href="'mailto:'+email">
						<img :src="emailImg" alt="Email İkon" id="email" width="50px"/>
						{{email}}
					</a>
				</li>
				<li class="bildirimSection">
					<a :href="'tel:'+tel">
					<img :src="telImg" id="telephone" alt="Telefon İkon" width="50px"/>
					{{tel}}
				</a>
				</li>
				<li class="bildirimSection">
					<iframe 
						:src="gmapLongUrl"
						width="100%"
						height="280"
						frameborder="0"
						style="border:0; border-radius:15px; padding-top: 2%;"
						allowfullscreen>
					</iframe><br>
					<a :href="gmapUrl" id="txtMarker" style="font-size: 14pt">
						<img :src="gmapMarkerImg" alt="Konum İkon" id="marker" width="50px"/>
						{{address}}
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
		
	import EmailIcon from '../../public/icons/Email.svg';
	import TelIcon from '../../public/icons/Telephone.svg';
	import AddressIcon from '../../public/icons/Marker.svg'; 

	export default {
		data() {
			return {
				email: 'maltin@ktun.edu.tr',
				emailImg: EmailIcon,
				tel: '+90 332 223 2380',
				telImg: TelIcon,
				gmapLongUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3834.3223551844135!2d32.50386231559806!3d38.02953720523341!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d08d17ca644997%3A0x5fdb801fa20c218c!2sTeknik+Bilimler+Meslek+Y%C3%BCksekokulu!5e1!3m2!1sen!2str!4v1559639480578!5m2!1sen!2str',
				gmapUrl: 'https://goo.gl/maps/owXokKB3Cw6USsgb7',
				gmapMarkerImg: AddressIcon,
				address: `Ardıçlı Mahallesi, İsmetpaşa Cad., 42250 Meslek Yüksekokulu Selçuklu/Konya`,
			}
		},

		props: {
      isVisible: {
        type: Boolean,
        required: true,
      }
		},

    methods: {
      togglePopUp(){
        this.$emit('PopUpToggled', this.isVisible);
      }
    }
	}
</script>

<style scoped>
	.pop-up{
		position: fixed;
		left: 35%;
		top: 20%;
		z-index: 10;
		width: 30%;
		height: 45%;
		padding: 25px 25px 25px 60px;
		background-color: #FAFAFA;
		border-radius: 25px;
		box-shadow: 0 10px 30px #333333aa;
		overflow-x: auto;
	}

	/*============== pop-up Scrollbar =================*/
	.pop-up::-webkit-scrollbar {
		width: 15px;
	}

	/* Track */
	.pop-up::-webkit-scrollbar-track {
		margin-top: 1.5em;
		margin-bottom: 1em;
	}

	/* Thumb */
	.pop-up::-webkit-scrollbar-thumb {
		transition: background-color .5s;
		-webkit-transition: background-color .5s;
		-webkit-border-radius: 10px;
		border-radius: 10px;
		background-color: #ADADAD;
		opacity: 0;
	}

	/* Thumb on hover */
	.pop-up::-webkit-scrollbar-thumb:hover {
		transition: background-color .5s;
		-webkit-transition: background-color .5s;
		background-color: #BBB;
		opacity: .9;
	}

	.pop-up::-webkit-scrollbar-corner {
		background-color: transparent;
	}

	/*========= close button ===========*/
	.closebtn{
		position: fixed;
		left: 36%;
		top: 22%;
		color: black;
		font-weight: bold;
		float: left;
		font-size: 24pt;
		line-height: 20px;
		cursor: pointer;
		transition: text-shadow .5s,top .5s;
		-webkit-transition: text-shadow .5s,top .5s;
	}

	.closebtn:hover{
		text-shadow: 0px 5px 2px #333333aa;
		top: 21%;
		transition: text-shadow .5s,top .5s;
		-webkit-transition: text-shadow .5s,top .5s;
	}

	#innerHtml >>> ul{
		margin-top: -2em;
	}

	#innerHtml >>> .bildirimSection{
		position: relative;
		margin: 1em 0em;
		right: 2em;
		padding: .5em 1em 2em 1em;
		width: 90%;

		cursor: pointer;
		border-radius: 1em;
		z-index: 10;
		font-size: 13pt;
		color: #222;
		background-color: white;
		transition: filter .7s, transform .5s;
		box-shadow: 0px 2px 2.5px #333333aa;
		transform: scale3d(1, 1, 1);
	}
	
	#innerHtml >>> .bildirimSection:hover{
		transition: filter .7s, transform .5s;
		filter: drop-shadow(0 2px 2.5px #3333338a);
		transform: scale3d(1.05, 1.05, 1);
	}

	#innerHtml >>> #email{
		padding: 5px;
		position: relative;
		top: .6em;
	}

	#innerHtml >>> #telephone{
		position: relative;
		top: .8em;
	}

	#innerHtml >>> #marker{
		float: left;
		position: relative;
		right: .2em;
		bottom: .4em;
		/* margin: 0 .3em .3em .4em; */
	}

	#innerHtml >>> #txtMarker{
		top: .2em;
		text-align: center;
	}

	#innerHtml >>> .bildirimSection>a{
		position: relative;
		display: inline;
		transition: text-shadow 300ms;
		color: #333;
		text-align: center;
		line-height: 5px;
		font-size: 17pt;
		padding-left: .5em;
	}
</style>